import { z } from 'zod';
import { meta } from '../meta';

export const ButtonPropsSchema = z.object({
  text: z.string().default('点击按钮').meta(meta({ label: '文字', setter: 'input' })),
  bgColor: z.string().default('#1677ff').meta(meta({ label: '背景色', setter: 'color' })),
  color: z.string().default('#ffffff').meta(meta({ label: '文字色', setter: 'color' })),
  fontSize: z.number().min(10).max(60).default(16).meta(meta({ label: '字号', setter: 'slider', min: 10, max: 60, step: 1 })),
  radius: z.number().min(0).max(100).default(6).meta(meta({ label: '圆角', setter: 'slider', min: 0, max: 100, step: 1 })),
  borderColor: z.string().default('transparent').meta(meta({ label: '边框色', setter: 'color' })),
});

export type ButtonProps = z.infer<typeof ButtonPropsSchema>;
